const BASE_URL = process.env.REACT_APP_API_URL || 'https://ayonkdesigns.com/api';

const getHeaders = (isFormData = false) => {
    // Support both token keys you might be using
    const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
    const headers = {};
    
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    
    // CRITICAL: If it's FormData (like image uploads), the browser automatically 
    // sets the Content-Type with the correct boundary. Do not set it manually.
    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
    }
    
    return headers;
};

const handleResponse = async (response) => {
    if (!response.ok) {
        let errorMsg = `HTTP Error ${response.status}`;
        try {
            const errData = await response.json();
            errorMsg = errData.message || errData.title || JSON.stringify(errData);
        } catch (e) {
            // Ignore parse errors on error responses
        }
        const error = new Error(errorMsg);
        error.response = { data: { message: errorMsg }, status: response.status };
        throw error;
    }

    // THE FIX: Safely parse response ONLY if there is text.
    // This prevents the "Unexpected end of JSON input" crash on 204 No Content.
    const text = await response.text();
    return text ? JSON.parse(text) : null;
};

export const apiClient = {
    get: async (endpoint) => {
        const res = await fetch(`${BASE_URL}${endpoint}`, { headers: getHeaders() });
        return handleResponse(res);
    },
    post: async (endpoint, data) => {
        const isFormData = data instanceof FormData;
        const res = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'POST',
            headers: getHeaders(isFormData),
            body: isFormData ? data : JSON.stringify(data)
        });
        return handleResponse(res);
    },
    put: async (endpoint, data) => {
        const isFormData = data instanceof FormData;
        const res = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'PUT',
            headers: getHeaders(isFormData),
            body: isFormData ? data : JSON.stringify(data)
        });
        return handleResponse(res);
    },
    patch: async (endpoint, data) => {
        const isFormData = data instanceof FormData;
        const res = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'PATCH',
            headers: getHeaders(isFormData),
            body: isFormData ? data : JSON.stringify(data)
        });
        return handleResponse(res);
    },
    delete: async (endpoint) => {
        const res = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'DELETE',
            headers: getHeaders()
        });
        return handleResponse(res);
    }
};
